import { atom } from 'recoil'

const crashDetectionAtom = atom({
  key: 'crashDetectionAtom',
  default: {
    isAutoUpdate: false,
  },
})

export default crashDetectionAtom
